module.exports = __webpack_public_path__ + "img/product_bg_02.04fc73f.webp";